'use client';

import { useTranslations } from 'next-intl';

const HomepagePromoBanner = () => {
  const t = useTranslations('header');


  if (!t.raw('isEnable')) {
    return null;
  }

  return (
    <div className="w-full bg-[#2B2B2B] text-white text-[15px] h-[44px] md:h-[50px] flex items-center justify-center">
      <div className="text-center">
        <span
          className="text-sm font-medium"
          dangerouslySetInnerHTML={{ __html: t.raw('promoText') }}
        />
      </div>
    </div>
  );
};

export default HomepagePromoBanner;